import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Icon } from 'rsuite';
import styled from 'styled-components';

const StyledIcon = styled(Icon)`
  color: #ffb300;
  font-size: 18px;
  margin-right: 5px;
`;

const AutoWidthModal = styled(Modal)`
  width: auto;
  max-width: 500px;
  padding: 0 5px;
  margin: 20px auto;
`;

function ConfirmationModal({
  show,
  title,
  children,
  onCancel,
  onConfirm,
  cancelButtonLabel,
  confirmButtonLabel,
  cancelButtonProps,
  confirmButtonProps,
  ...props
}) {
  return (
    <AutoWidthModal
      size="md"
      backdrop="static"
      onHide={onCancel}
      show={show}
      {...props}
    >
      <Modal.Header>
        <Modal.Title>
          <StyledIcon icon="remind" /> {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ fontSize: 15 }}>{children}</Modal.Body>
      <Modal.Footer>
        <Button
          color="orange"
          appearance="ghost"
          onClick={onCancel}
          {...cancelButtonProps}
        >
          <Icon icon="close-circle" /> {cancelButtonLabel}
        </Button>
        <Button
          color="green"
          appearance="ghost"
          onClick={onConfirm}
          {...confirmButtonProps}
        >
          <Icon icon="check-circle" /> {confirmButtonLabel}
        </Button>
      </Modal.Footer>
    </AutoWidthModal>
  );
}

ConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cancelButtonLabel: PropTypes.string,
  confirmButtonLabel: PropTypes.string,
  cancelButtonProps: PropTypes.shape({}),
  confirmButtonProps: PropTypes.shape({})
};

ConfirmationModal.defaultProps = {
  cancelButtonLabel: 'Cancel',
  confirmButtonLabel: 'Confirm',
  cancelButtonProps: {},
  confirmButtonProps: {}
};

export default ConfirmationModal;
